<template>
  <div>
    <PoolPlayAddGameModal :isEditingGame="isEditingGame" :association_id="association_id" :eventId="eventId"
      @RefreshPoolPlayGames="getPoolPlayGames" :field="selectedFieldForModal" :time="selectedTimeForModal"
      :date="selectedDateForModal" :gameType="gameType" :totalGames="totalGames" :selectedGameName="selectedGameName"
      :team1-id="team1Id" :team2-id="team2Id" :game_id="game_id" :umpireId="umpireId" />
    <div class="sub-header-container">
      <div class="play2-loader" v-if="showEventHeadingLoader">
        <content-placeholders :rounded="true">
          <content-placeholders-text :lines="2" />
        </content-placeholders>
      </div>

      <div class="pool-play-event-heading" v-else>
        <div class="pool-play-event-name">{{ eventName }}</div>
        <div class="pool-play-event-date" v-if="events && events.exactStartDate && events.exactEndDate">
          {{ formatDateRange(events.exactStartDate, events.exactEndDate) }}
        </div>
      </div>

      <div class="go-listing-div" @click="goEventListing">
        <div class="go-listing-img">
          <img src="../../assets/Svg/close-editor.svg" alt="" />
        </div>
        <span>Close MatchGeni</span>
      </div>
    </div>

    <div class="pool-play-left-menu overflow-auto search"
      v-if="scheduleData && scheduleData.length > 0 && AssignUmpire === true">
      <div class="selected-division-container mb-2">
        <button class="btn pl-0" @click="handleBackClickFromUmpire">
          <img src="../../assets/Svg//back-arrow.svg" alt="" />
        </button>
        <div>
          <div class="selected-division-name">
            Umpire Assignment
          </div>
          <div class="selected-division-date">
            Back
          </div>
        </div>
      </div>

      <div v-if="showUmpireListing == true">
        <div class="products-list-shim bordered-loader p-0">
          <content-placeholders :rounded="true">
            <content-placeholders-img />
            <content-placeholders-heading />
            <content-placeholders-img />
            <content-placeholders-heading />
            <content-placeholders-img />
          </content-placeholders>
        </div>
      </div>

      <div class="no-event-wrap" v-else-if="
        (!availableUmpires || availableUmpires.length === 0) &&
        showUmpireListing == false
      ">
        <img src="../../assets/Svg/no-data.svg" alt />
        <p class="header">No Umpire found.</p>
        <p class="info">There are no Umpires to display.</p>
      </div>

      <div v-else-if="
        (availableUmpires || availableUmpires.length > 0) &&
        showUmpireListing == false
      ">
        <div class="teams-pool-detail mb-1">
          {{ availableUmpiresCount }} Umpire{{
          availableUmpiresCount === 1 ? "" : "s"
          }}
        </div>
        <div class="seed-details">
          Total game{{ totalGamesForUmpire === 1 ? "" : "s" }}:
          {{ totalGamesForUmpire }}
        </div>
        <div class="seed-details">
          Unassigned
          {{
          poolNonUmpireGames + bracketNonUmpireGames === 1 ? "game" : "games"
          }}: {{ poolNonUmpireGames + bracketNonUmpireGames }}
        </div>
        <div class="umpire-warning-text ml-2">
          <ul v-if="poolNonUmpireGames > 0 || bracketNonUmpireGames > 0">
            <li v-if="poolNonUmpireGames > 0">
              Pool Game{{ poolNonUmpireGames === 1 ? "" : "s" }}:
              {{ poolNonUmpireGames }} unassigned
            </li>
            <li v-if="bracketNonUmpireGames > 0">
              Bracket Game{{ bracketNonUmpireGames === 1 ? "" : "s" }}:
              {{ bracketNonUmpireGames }} unassigned
            </li>
          </ul>
        </div>

        <div v-if="hasUnscheduledGames" class="tip-wrapper mx-0 mt-3 align-items-start">
          <span>Auto Assign Umpires</span>
          <p>
            Auto-assign available umpires to all unassigned games to quickly
            complete your schedule. You can review and adjust assignments
            afterward.
          </p>
          <small @click="autoAssign(0)" class="cursor-pointer position-relative mt-2">
            <div v-if="isLoadingArray[0]" style="width: 24px; height: 24px; position: relative;">
              <img src="../../assets/loader.gif" alt="" style="width: 100%;" />
            </div>
            <div v-else>Auto Assign</div>
          </small>
        </div>

        <div class="drag-drop-section">
          <div class="teams-pool-detail mb-1">Drag & Drop</div>
          <p>
            Drop umpire to a game slot to assign them to that game. Dropping on
            a field column assigns the umpire to all unscheduled games in that
            field.
          </p>
        </div>

        <div class="row no-gutters mt-2">
          <div class="col-12 mb-3" v-for="umpire in availableUmpires" :key="umpire.id">
            <div class="card h-100 shadow-sm border-0">
              <div class="card-body pool-game-card">

                <!-- Drag handle -->
                <div class="drag-handle" draggable="true" @touchstart="onTouchStartUmpire(umpire, $event)"
                  @touchmove="onTouchMoveUmpire($event)" @touchend="onTouchEndUmpire($event)"
                  @dragstart="onDragStartUmpire(umpire, $event)" title="Drag this umpire" style="cursor: grab;">
                  <img src="../../assets/Svg/grip-handle.svg" alt="" />
                </div>
                <div class="d-flex align-items-center justify-content-between w-100">
                  <p class="umpire-names-data">
                    {{ umpire?.umpire?.name }}
                  </p>

                  <div class="umpire-counter-badge">
                    {{ umpire?.assigned_games_count }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="pool-play-left-menu search" v-else-if="scheduleData && scheduleData.length > 0 && tournamentSelected">
      <div class="selected-division-container mb-2">
        <button class="btn pl-0" @click="handleBackClick">
          <img src="../../assets/Svg//back-arrow.svg" alt="" />
        </button>
        <div>
          <div class="selected-division-name">
            {{ selectedTournamentName }}
          </div>
          <div class="selected-division-date" v-if="
            selectedTournament &&
            selectedTournament.exactStartDate &&
            selectedTournament.exactEndDate
          ">
            {{
            formatDateRange(
            selectedTournament.exactStartDate,
            selectedTournament.exactEndDate
            )
            }}
          </div>
        </div>
      </div>

      <div class="games-scrollable-div">
        <div class="mb-3" v-if="selectedTournamentName">
          <div v-if="selectedTournament.pool_count == 1">
            {{ selectedTournament.teamCounts }} Teams
          </div>
          <div class="teams-pool-detail" v-else>
            {{ selectedTournament.teamCounts }} Teams across
            {{ selectedTournament.pool_count }} Pools
          </div>
          <div class="seed-details" v-if="
            selectedTournament.pool_game_guarantee &&
            selectedTournament.bracket_format_name
          ">
            {{ selectedTournament.pool_game_guarantee }} games Round Robin to
            seed {{ selectedTournament.tournamentName }}
            {{ selectedTournament.bracket_format_name }} bracket.
          </div>
          <div class="seed-details" v-else>
            {{ this.events.game_guarantee }} games Round Robin to seed
            {{ selectedTournament.tournamentName }}
            {{ this.events?.bracket_format?.bracket_name }} bracket.
          </div>
        </div>

        <div class="my-3" v-if="selectedTournamentName">
          <div class="pool-play-title mb-2">Pool Play</div>

          <div class="total-games-count">
            Total Games: {{ teamDistributionSummary.totalGames }}
          </div>

          <div class="total-games-count">Team Distribution:</div>
          <ul class="total-games-count mb-2">
            <li v-for="(count, games) in teamDistributionSummary.distribution" :key="games">
              {{ count }} team<span v-if="count > 1">s</span> play
              {{ games }} game<span v-if="games > 1">s</span> each
            </li>
          </ul>

          <p v-if="teamDistributionSummary.remainingGames > 0" class="unscheduled-games">
            There
            {{ teamDistributionSummary.remainingGames > 1 ? "are" : "is" }}
            {{ teamDistributionSummary.remainingGames }}
            game<span v-if="teamDistributionSummary.remainingGames > 1">s</span>
            left to schedule. Let’s get them on the calendar!
          </p>
        </div>

        <div class="row">
          <div class="col-12 mb-3" v-for="game in scheduleData.filter(
            (g) => g.division_id === selectedTournament.id
          )" :key="game.db_id">
            <div class="card h-100 shadow-sm border-0">
              <div class="card-body pool-game-card">
                <!-- Drag handle -->
                <div class="drag-handle" draggable="true" @touchstart="onTouchStart(game, $event)"
                  @touchmove="onTouchMove($event)" @touchend="onTouchEnd($event)" @dragstart="onDragStart(game, $event)"
                  title="Drag this game" style="cursor: grab;">
                  <img src="../../assets/Svg/grip-handle.svg" alt="" />
                </div>
                <div class="flex-grow-1">
                  <div class="teams-name-ellipsis-div">
                    <div class="team-pool-details">
                      <p class="card-title teams-names mb-0">
                        <template v-if="game?.game_type === 2">
                          #{{ game?.game_name || "Unnamed Game" }}
                        </template>
                        <template v-else>
                          #{{ game?.teamA_data?.team_sr_no || "TBD" }}
                          {{ game?.teamA_data?.team_name || "" }}
                          <span>vs</span>
                          #{{ game?.teamB_data?.team_sr_no || "TBD" }}
                          {{ game?.teamB_data?.team_name || "" }}
                        </template>
                      </p>

                      <p class="card-text pool-details" v-if="selectedTournament.pool_count > 1">
                        <span class="card-text">Pool:</span>
                        {{ game?.teamA_data?.pool_name || "N/A" }}
                      </p>
                    </div>

                    <div class="opt mt-0 position-relative cursor-pointer" @click.stop="openGameOption(game)"
                      v-click-outside="onClickOutside">
                      <img src="../../assets/Svg/ellipse.svg" alt="" />
                      <div class="sub-setting-options edit-event-options" v-if="activeGameId === game.db_id">
                        <ul class="mb-0 border-bottom-0 pb-0 d-block">
                          <li class="cursor-pointer" v-if="
                            game.assignedDate &&
                            game.assignedTime &&
                            game.assignedFieldId
                          " @click="
                              handleAvailableClick(
                                game.assignedFieldId,
                                game.assignedTime,
                                game.assignedDate,
                                true
                              )
                              ">
                            <img src="../../assets/Svg/team/team-options/edit-2.svg" />
                            <p>Edit Game</p>
                          </li>

                          <li class="cursor-pointer" @click="deleteGame(game)">
                            <img src="../../assets/Svg/trash.svg" />
                            <p>Delete Game</p>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>

                  <!-- Show assigned info if present -->
                  <div v-if="
                    game.assignedDate &&
                    game.assignedTime &&
                    game.assignedFieldName
                  " class="assigned-info mt-2 text-success">
                    <div>
                      <div class="assigned-img-text-div">
                        <div class="assigned-img-div">
                          <img src="../../assets/Svg/calendar-date.svg" alt="" />
                        </div>
                        {{ formatAssignedDate(game.assignedDate) }}
                      </div>
                      <div class="assigned-img-text-div">
                        <div class="assigned-img-div">
                          <img src="../../assets/Svg/clock-time.svg" alt="" />
                        </div>
                        {{ game.assignedTime }}
                      </div>
                      <div class="assigned-img-text-div">
                        <div class="assigned-img-div">
                          <img src="../../assets/Svg/maximize-field.svg" alt="" />
                        </div>
                        {{ game.assignedFieldName }}
                      </div>
                    </div>

                    <!-- Unlink button in game card (optional) -->
                    <button class="btn unlink-btn btn-sm mt-1" @click="unlinkGame(game)" title="Unlink this game">
                      Unlink
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="shop-left-menu pool-play-left-menu search" v-else>
      <div class="position-relative mb-3">
        <div class="switch-btn pool-switch-btn mb-0 d-flex flex-row align-items-center" @click="toggleDropdown"
          v-click-outside="closeDropdown">
          <div>
            <span>Switch Division</span>
            <p class="association-data">
              {{ selectedTournamentName || "Select Division" }}
            </p>
            <small class="association-tournament-date">{{
              selectedTournamentDate
              }}</small>
          </div>
          <img :src="arrow_down" alt="arrow-down" />
        </div>

        <div class="dropdown-menu-content pool-dropdown-menu-content" v-if="activeDropdown" ref="dropdownMenu">
          <input v-model="searchQuery" type="text" class="form-control" placeholder="Search Division" @click.stop />
          <div v-if="
            filteredTournaments.length === 0 && showLoaderTournament === 0
          " class="no-results">
            No results found
          </div>
          <div v-else>
            <div v-for="tournament in filteredTournaments" :key="tournament.guid" class="dropdown-item"
              @click="selectTournament(tournament)">
              <span>{{ tournament.tournamentName }}</span>
            </div>
            <div class="position-relative py-3" v-if="showLoaderTournament === 1">
              <div class="lds-dual-ring-media"></div>
            </div>
          </div>
        </div>
      </div>

      <div class="mt-3" v-if="selectedTournamentName">
        <div class="teams-pool-detail mb-1" v-if="selectedTournament.pool_count == 1">
          {{ selectedTournament.teamCounts }} Teams
        </div>
        <div class="teams-pool-detail mb-1" v-else>
          {{ selectedTournament.teamCounts }} Teams across
          {{ selectedTournament.pool_count }} Pools
        </div>
        <div class="seed-details" v-if="
          selectedTournament.pool_game_guarantee &&
          selectedTournament.bracket_format_name
        ">
          {{ selectedTournament.pool_game_guarantee }} games Round Robin to seed
          {{ selectedTournament.tournamentName }}
          {{ selectedTournament.bracket_format_name }} bracket.
        </div>
        <div class="seed-details" v-else>
          {{ this.events.game_guarantee }} games Round Robin to seed
          {{ selectedTournament.tournamentName }}
          {{ this.events?.bracket_format?.bracket_name }} bracket.
        </div>
      </div>

      <div class="umpire-warning-box mt-3" v-if="hasScheduledGames">
        <div class="umpire-warning-title">
          <img src="../../assets/Svg/warning-2.svg" alt="umpire-assignment" />
          <span>Umpire Assignment Incomplete</span>
        </div>

        <div class="umpire-warning-text">
          Some games are missing umpire assignments. Please review and assign umpires to finalize the schedule.

          <ul v-if="poolNonUmpireGames > 0 || bracketNonUmpireGames > 0">
            <li v-if="poolNonUmpireGames > 0">
              Pool Games: {{ poolNonUmpireGames }} unassigned
            </li>
            <li v-if="bracketNonUmpireGames > 0">
              Bracket Games: {{ bracketNonUmpireGames }} unassigned
            </li>
          </ul>
        </div>

        <a class="assign-umpires-btn" @click="showUmpireAssignmentDiv">
          Assign Umpires
        </a>
      </div>


      <div class="mt-3">
        <div class="pool-play-title mb-2">Pool Play</div>
        <div v-if="selectedTournament?.has_pool_games == 1">
          <div class="total-games-count">
            Total Games: {{ teamDistributionSummary.totalGames }}
          </div>

          <div class="total-games-count">Team Distribution:</div>
          <ul class="total-games-count mb-2">
            <li v-for="(count, games) in teamDistributionSummary.distribution" :key="games">
              {{ count }} team<span v-if="count > 1">s</span> play
              {{ games }} game<span v-if="games > 1">s</span> each
            </li>
          </ul>

          <p v-if="teamDistributionSummary.remainingGames > 0" class="unscheduled-games">
            There
            {{ teamDistributionSummary.remainingGames > 1 ? "are" : "is" }}
            {{ teamDistributionSummary.remainingGames }}
            game<span v-if="teamDistributionSummary.remainingGames > 1">s</span>
            left to schedule. Let’s get them on the calendar!
          </p>
        </div>
        <div v-if="selectedTournament?.has_pool_games != 1" class="mt-2">
          Looks like there are no pool games yet! Just use the options below to
          create them.
        </div>
      </div>

      <div class="mt-3" v-if="selectedTournament?.has_pool_games != 1">
        <div class="text-toogle-div">
          <div class="text-toogle-div-heading">Avoid Rematches</div>
          <toggle-button class="m-0 tog-btn" v-model="avoidRematches" :value="false" :sync="true" :width="34"
            :color="{ checked: '#188ef5', unchecked: '#ccc' }" />
        </div>
        <div>Prevent the same teams playing twice.</div>
      </div>

      <div class="generate-pool-btn mt-3">
        <button class="position-relative" @click="generatePoolPlay" :disabled="isButtonLoading">
          <div v-if="isButtonLoading" class="lds-dual-ring"></div>
          <span v-else>
            {{
            selectedTournament?.has_pool_games == 1
            ? "View Pool Play"
            : "Generate Pool Play"
            }}
          </span>
        </button>
      </div>

      <div class="mt-3">
        <div class="pool-play-title">Bracket Play</div>
        <div class="products-list-shim p-0 pt-3" v-if="showBracketLoader">
          <content-placeholders :rounded="true">
            <content-placeholders-img />
            <content-placeholders-heading />
          </content-placeholders>
          <content-placeholders class="mt-3" :rounded="true">
            <content-placeholders-img />
            <content-placeholders-heading />
          </content-placeholders>
        </div>
        <div v-if="brackets.length > 0 && showBracketLoader == 0">

          <div v-for="(summary, index) in bracketSeedSummaries" :key="'summary-' + index">
            #{{ summary.startSeed }} to #{{ summary.endSeed }}
            play {{ summary.format }} bracket for {{ summary.name }}
          </div>

          <div v-for="(bracket, index) in brackets" :key="index" class="brackets-images-div mt-3"
            @click="goToBracket(bracket?.guid)" style="cursor: pointer;">
            <div>
              <div class="bracket-image-division-name mx-0">
                <img src="../../assets/Svg/hierarchy.svg" alt="hierarchy" />
                <div class="bracket-tournament-name">
                  <p>
                    {{ bracket?.bracket_name }}
                  </p>
                </div>
              </div>
              <span class="bracket-team-count" style="margin-left: 28px">
                {{ bracket?.teamCounts }}
                {{ bracket?.teamCounts === 1 ? "Team" : "Teams" }} -
                {{
                bracket?.event_tournament?.bracket_format_info?.bracket_name ||
                bracket?.event_tournament?.event?.bracket_format?.bracket_name
                }}
              </span>
            </div>
            <BracketEllipsis :bracket="bracket" :tournamentTeams="tournamentTeams" :association_id="association_id"
              @click.stop />
          </div>
        </div>
        <div class="mt-2" v-if="brackets.length == 0 && showBracketLoader == 0">
          No brackets yet! Just tap 'Add Bracket' to create one and start
          setting it up.
        </div>
      </div>


      <div class="generate-pool-btn mt-3" @click="addBracket">
        <button>
          <!-- <div v-if="isGenerating">
                        <img src="../../assets/loader.gif" alt="" />
                    </div>
                    <span v-else> -->
          Add Bracket
          <!-- </span> -->
        </button>
      </div>
    </div>

    <div class="shop-page-products pool-right-side pl-0 pb-3 pt-3">
      <div v-if="showFieldsLoader">
        <div class="products-list-shim bordered-loader">
          <content-placeholders :rounded="true">
            <content-placeholders-img />
            <content-placeholders-heading />
            <content-placeholders-img />
            <content-placeholders-heading />
            <content-placeholders-img />
          </content-placeholders>
        </div>
      </div>

      <!-- OPTIMIZED TEMPLATE - Avoid multiple function calls -->
      <div v-if="scheduleTables.length > 0 && !showFieldsLoader">
        <div v-for="(table, tableIndex) in scheduleTables" :key="tableIndex" class="mb-4">
          <div :ref="'table-' + getDateForComparison(table.date)">
            <h5 class="field-date mb-3">{{ table.formattedDate }}</h5>
            <div class="pool-table-container">
              <table class="schedule-table">
                <thead>
                  <tr>
                    <th class="field-header">Time</th>
                    <th v-for="field in table.fields" :key="field.id" class="field-header" :data-field-id="field.id"
                      @dragover.prevent @drop="handleDropOnField(field, null, table.date, $event)">
                      {{ field.field_name }}
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(timeSlot, timeIndex) in table.timeSlots" :key="timeIndex">
                    <td class="field-cell">
                      <strong>{{ timeSlot.time }}</strong>
                    </td>
                    <td v-for="field in table.fields" :key="field.id" class="field-cell" @dragover.prevent
                      @drop="handleDrop(field, timeSlot, table.date, $event)" :data-field-id="field.id"
                      :data-time-slot="timeSlot.time" :data-date="getDateForComparison(table.date)" :class="{
                        assigned: getAssignedGame(field.id, timeSlot.time, getDateForComparison(table.date)),
                        'invalid': !isDateWithinTournamentRange(table.date),
                        'no-game': AssignUmpire && !getAssignedGame(field.id, timeSlot.time, getDateForComparison(table.date)) && isDateWithinTournamentRange(table.date),
                        available: !getAssignedGame(field.id, timeSlot.time, getDateForComparison(table.date)) && isDateWithinTournamentRange(table.date),
                        'current-division': getAssignedGame(field.id, timeSlot.time, getDateForComparison(table.date))?.division_id === selectedTournament.id,
                        'other-division': getAssignedGame(field.id, timeSlot.time, getDateForComparison(table.date))?.division_id !== selectedTournament.id,
                        'no-umpire': AssignUmpire && getAssignedGame(field.id, timeSlot.time, getDateForComparison(table.date)) && !getAssignedGame(field.id, timeSlot.time, getDateForComparison(table.date))?.umpire,
                        'umpire-assigned': AssignUmpire && getAssignedGame(field.id, timeSlot.time, getDateForComparison(table.date))?.umpire,
                      }"
                      :style="getAssignedGame(field.id, timeSlot.time, getDateForComparison(table.date)) ? getDivisionStyle(getAssignedGame(field.id, timeSlot.time, getDateForComparison(table.date)).division) : {}"
                      @click="handleAvailableClick(field, timeSlot.time, table.date, false)">

                      <!-- Assigned Game (shown regardless of date validity) -->
                      <div v-if="assignedGameFor(field.id, timeSlot.time, table.date)" class="assigned-game-container"
                        :title="assignedGameFor(field.id, timeSlot.time, table.date).division_id == selectedTournament.id ? 'Drag this game' : ''"
                        :draggable="assignedGameFor(field.id, timeSlot.time, table.date).division_id == selectedTournament.id"
                        @dragstart="onDragStart(assignedGameFor(field.id, timeSlot.time, table.date), $event)"
                        @touchstart="onTouchStart(assignedGameFor(field.id, timeSlot.time, table.date), $event)"
                        @touchmove="onTouchMove($event)" @touchend="onTouchEnd($event)" :style="{
                          cursor: assignedGameFor(field.id, timeSlot.time, table.date).division_id == selectedTournament.id ? 'grab' : 'not-allowed',
                          userSelect: assignedGameFor(field.id, timeSlot.time, table.date).division_id == selectedTournament.id ? 'auto' : 'none',
                          touchAction: 'none'
                        }">
                        <div class="game-info">
                          <div class="umpires-names" v-if="
                            AssignUmpire == true &&
                            assignedGameFor(
                              field.id,
                              timeSlot.time,
                              table.date
                            )?.umpire
                          ">
                            {{
                            assignedGameFor(
                            field.id,
                            timeSlot.time,
                            table.date
                            )?.umpire?.name
                            }}
                          </div>
                          <div class="no-umpires-names" v-if="
                            AssignUmpire == true &&
                            !assignedGameFor(
                              field.id,
                              timeSlot.time,
                              table.date
                            )?.umpire
                          ">
                            No Umpire Assigned
                          </div>
                          <div class="teams-names teams-names2">
                            <template v-if="
                              assignedGameFor(
                                field.id,
                                timeSlot.time,
                                table.date
                              )
                            ">
                              <template v-if="
                                assignedGameFor(
                                  field.id,
                                  timeSlot.time,
                                  table.date
                                ).game_type === 2
                              ">
                                #{{
                                assignedGameFor(
                                field.id,
                                timeSlot.time,
                                table.date
                                ).game_name || "Unnamed Game"
                                }}
                              </template>
                              <template v-else>
                                #{{
                                assignedGameFor(
                                field.id,
                                timeSlot.time,
                                table.date
                                )?.teamA_data?.team_sr_no || "TBD"
                                }}
                                <span class="vs-text">vs</span>
                                #{{
                                assignedGameFor(
                                field.id,
                                timeSlot.time,
                                table.date
                                )?.teamB_data?.team_sr_no || "TBD"
                                }}
                              </template>
                            </template>
                          </div>
                          <div class="division-names">
                            {{
                            assignedGameFor(
                            field.id,
                            timeSlot.time,
                            table.date
                            )?.division
                            }}
                          </div>
                        </div>

                        <button v-if="
                          AssignUmpire == false &&
                          assignedGameFor(
                            field.id,
                            timeSlot.time,
                            table.date
                          ).division_id == selectedTournament.id
                        " class="btn btn-sm unlink-btn mt-1" @click.stop="
                            unlinkGame(
                              assignedGameFor(
                                field.id,
                                timeSlot.time,
                                table.date
                              )
                            )
                            " title="Unlink this game">
                          Unlink
                        </button>
                      </div>

                      <div v-else-if="AssignUmpire == false && isDateWithinTournamentRange(table.date)"
                        class="availability-status available">
                        <span class="available-text">Available</span>
                        <span class="add-game-hover-text">
                          <div>
                            <img src="../../assets/Svg/add-team.svg" alt="" />
                          </div>
                          Add Game
                        </span>
                      </div>

                      <!-- If no assigned game and date is invalid -->
                      <div v-else-if="AssignUmpire == true" class="availability-status invalid">
                        No Game Scheduled
                      </div>
                      <div v-else class="availability-status invalid">
                        Invalid date for <br />
                        Division
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>

      <div v-if="
        (!scheduleTables || scheduleTables.length === 0) &&
        showFieldsLoader === 0
      " class="no-event-wrap">
        <img src="../../assets/Svg/no-data.svg" alt />
        <p class="header">No field found.</p>
        <p class="info">There are no field against parks to display.</p>
      </div>
    </div>
    <EditBracketModal @RefreshBracketOnEdit="onRefreshBracketOnEdit" />
    <AddBracketModal />
  </div>
</template>

<script>
import { required } from "vuelidate/lib/validators";
import axios from "axios";
import PoolPlayAddGameModal from "../../components/PoolPlayGenerator/PoolPlayAddGameModal.vue";
import AddBracketModal from "./AddBracketModal.vue";
import BracketEllipsis from "../../components/Tournaments/BracketEllipsis.vue";
import EditBracketModal from "../PoolPlayGenerator/EditBracketModal.vue"
export default {
  name: "PoolPlayGenerator",
  components: {
    PoolPlayAddGameModal,
    AddBracketModal,
    EditBracketModal,
    BracketEllipsis,
  },
  data() {
    return {
      tournamentsData: [],
      selectedTournament: {},
      scheduled: {},
      selectedTournamentGuid: null,
      tournament_time: "",
      gamesPerTeam: 2,
      gamesPerField: 3,
      startTime: "08:00 AM",
      endTime: "05:00 PM",
      tournamentTeams: [],
      timeError: "",
      activeDropdown: false,
      arrow_down: require("../../assets/Svg/arrow-down.svg"),
      selectedFields: [],
      avoidRematches: true,
      avoidBackToBackGames: true,
      scheduleData: [],
      editingCell: null,
      pools: [],
      showLoader1: 1,
      editValue: "",
      isGenerating: false,
      isTournamentLoading: true,
      parkField: [],
      allFields: [],
      searchQuery: "",
      eventId: null,
      association_id: 0,
      poolLoader: false,
      events: {},
      eventName: "",
      showEventHeadingLoader: 0,
      showFieldsLoader: 1,
      open: false,
      openEnd: false,
      startDate: null,
      endDate: null,
      gameOptions: [
        { id: 1, name: "Pool Play" },
        { id: 2, name: "Bracket" },
      ],
      fieldAssignments: [],
      draggedGame: null,
      draggedUmpire: null,
      summaryData: 0,
      tournamentSelected: false,
      divisionColorMap: {},
      usedColors: new Set(),
      activeGameId: null,
      selectedFieldForModal: {},
      selectedTimeForModal: "",
      selectedDateForModal: "",
      game_id: "",
      totalGames: 0,
      team1Id: null,
      team2Id: null,
      gameType: "",
      umpireId: "",
      selectedGameName: null,
      isEditingGame: false,
      divisionPage: 1,
      divisionlastPage: 1,
      brackets: [],
      showBracketLoader: 1,

      availableUmpires: [],
      poolNonUmpireGames: 0,
      bracketNonUmpireGames: 0,
      AssignUmpire: false,
      showUmpireListing: false,
      availableUmpiresCount: "",
      totalGamesForUmpire: "",
      isLoadingArray: [],
      isDragging: false,
      touchStartPos: { x: 0, y: 0 },
      dragPreview: null,

      allDay: false,
    };
  },
  validations() {
    return {
      startTime: { required },
      endTime: { required },
    };
  },
  computed: {
    isButtonLoading() {
      return this.isTournamentLoading || !this.selectedTournament || this.isGenerating;
    },
    hasScheduledGames() {
      return this.scheduleData.some(game => game.assignedFieldId && game.assignedTime && game.assignedDate);
    },
    bracketSeedSummaries() {
      let currentSeed = 1;
      return this.brackets.map(bracket => {
        const startSeed = currentSeed;
        const endSeed = currentSeed + bracket.teamCounts - 1;
        currentSeed = endSeed + 1;

        return {
          startSeed,
          endSeed,
          format: this.getBracketFormat(bracket),
          name: bracket?.bracket_name
        };
      });
    },
    hasUnscheduledGames() {
      return this.scheduleData.some(game =>
        game.assignedFieldId != null &&
        game.assignedTime != null &&
        game.assignedDate != null &&
        game.umpire == null
      );
    },
    selectedTournamentDate() {
      const tournament = this.tournamentsData.find(
        (t) => t.guid === this.selectedTournamentGuid
      );
      if (!tournament || !tournament.exactStartDate || !tournament.exactEndDate)
        return "";

      const start = new Date(tournament.exactStartDate);
      const end = new Date(tournament.exactEndDate);

      const format = (date) => {
        const weekday = date.toLocaleDateString("en-US", { weekday: "short" });
        const month = date.toLocaleDateString("en-US", { month: "short" });
        const day = date.getDate();
        return `${weekday} ${month} ${day}`;
      };

      return `${format(start)} - ${format(end)}, ${end.getFullYear()}`;
    },
    filteredGamesCount() {
      return this.scheduleData.filter(
        (g) => g.division_id === this.selectedTournament.id
      ).length;
    },
    assignedGamesMap() {
      const map = {};
      this.scheduleData.forEach((game) => {
        if (game.assignedFieldId && game.assignedTime && game.assignedDate) {
          const key = `${game.assignedFieldId}-${game.assignedTime}-${game.assignedDate}`;
          map[key] = game;
        }
      });
      return map;
    },
    selectedTournamentName() {
      const tournament = this.tournamentsData.find(
        (t) => t.guid === this.selectedTournamentGuid
      );
      return tournament ? tournament.tournamentName : "";
    },
    sortedTournaments() {
      if (!this.tournamentsData) return [];
      const sorted = [...this.tournamentsData].sort((a, b) => {
        const nameA = (a.tournamentName || "").toUpperCase();
        const nameB = (b.tournamentName || "").toUpperCase();
        return nameA.localeCompare(nameB);
      });
      return sorted;
    },
    filteredTournaments() {
      const query = (this.searchQuery || "").trim().toLowerCase();
      const filtered = this.sortedTournaments.filter((t) =>
        (t.tournamentName || "").toLowerCase().includes(query)
      );
      return filtered;
    },
    scheduleTables() {
      if (
        !this.startDate ||
        !this.endDate ||
        !this.startTime ||
        !this.endTime ||
        !this.tournament_time ||
        this.allFields.length === 0
      ) {
        return [];
      }

      const tables = [];
      const start = new Date(this.startDate);
      const end = new Date(this.endDate);

      for (
        let date = new Date(start);
        date <= end;
        date.setDate(date.getDate() + 1)
      ) {
        const currentDate = new Date(date);
        const timeSlots = this.generateTimeSlots(
          this.startTime,
          this.tournament_time,
          this.endTime
        );

        tables.push({
          date: currentDate,
          formattedDate: this.formatTableDate(currentDate),
          timeSlots,
          fields: this.selectedFields,
        });
      }

      return tables;
    },
    selectedTournamentGames() {
      return this.scheduleData.filter(
        (game) =>
          game.division_id === this.selectedTournament.id &&
          game.game_type === 1
      );
    },
    teamDistributionSummary() {
      const teamGameCounts = {};
      let scheduledGames = 0;

      for (const game of this.selectedTournamentGames) {
        const teamAId = game.teamA;
        const teamBId = game.teamB;

        // Count all games for distribution
        if (!teamGameCounts[teamAId]) teamGameCounts[teamAId] = 0;
        if (!teamGameCounts[teamBId]) teamGameCounts[teamBId] = 0;

        teamGameCounts[teamAId]++;
        teamGameCounts[teamBId]++;

        // Only increment scheduled count if date, time, and field are set
        const isScheduled =
          game.assignedDate && game.assignedTime && game.assignedFieldId;
        if (isScheduled) scheduledGames++;
      }

      const distribution = {};
      for (const count of Object.values(teamGameCounts)) {
        distribution[count] = (distribution[count] || 0) + 1;
      }

      const distributionText = Object.entries(distribution).map(
        ([games, count]) => {
          return `${count} team${count > 1 ? "s" : ""} play ${games} game${games > 1 ? "s" : ""
            } each`;
        }
      );

      const totalTeams = Object.keys(teamGameCounts).length;
      const totalGames = this.selectedTournamentGames.length;
      const remainingGames = totalGames - scheduledGames;

      return {
        totalGames,
        totalTeams,
        distribution,
        distributionText,
        totalScheduledGamePairs: scheduledGames,
        remainingGames,
      };
    },
  },
  methods: {
    // Touch start handler for mobile
    onTouchStart(game, event) {
      if (!game) return;

      this.draggedGame = game;
      this.isDragging = false; // Will be set to true on touch move
      
      const touch = event.touches[0];
      this.touchStartPos = {
        x: touch.clientX,
        y: touch.clientY
      };
      
      // Store the original element for reference
      this.originalElement = event.currentTarget;
      console.log("consoling touch", this.originalElement);
      
      // Prevent default to avoid scrolling while dragging
      event.preventDefault();
      
      // Add visual feedback to original element
      if (this.originalElement) {
        this.originalElement.style.opacity = '0.7';
        this.originalElement.style.transform = 'scale(0.95)';
      }
    },

    // Touch move handler
    onTouchMove(event) {
      if (!this.draggedGame) return;
      
      const touch = event.touches[0];
      const deltaX = Math.abs(touch.clientX - this.touchStartPos.x);
      const deltaY = Math.abs(touch.clientY - this.touchStartPos.y);
      
      // Start dragging if moved more than 10px
      if (!this.isDragging && (deltaX > 10 || deltaY > 10)) {
        this.isDragging = true;
        this.createDragPreview(touch);
      }
      
      if (this.isDragging) {
        this.updateDragPreview(touch);
        this.highlightDropZones(touch);
        event.preventDefault();
      }
    },

    highlightDropZones(touch) {
      // Remove previous highlights
      document.querySelectorAll('.drop-zone-highlight').forEach(el => {
        el.classList.remove('drop-zone-highlight');
      });
      
      // Find and highlight current drop zone
      const elementBelow = document.elementFromPoint(touch.clientX, touch.clientY);
      if (elementBelow) {
        const dropZone = elementBelow.closest('.field-cell');
        if (dropZone && this.isValidDropZone(dropZone)) {
          dropZone.classList.add('drop-zone-highlight');
        }
      }
    },

    isValidDropZone(dropZoneElement) {
      const fieldId = dropZoneElement.dataset.fieldId;
      const timeSlot = dropZoneElement.dataset.timeSlot;
      const date = dropZoneElement.dataset.date;
      
      if (!fieldId || !timeSlot || !date) return false;
      
      // Check if date is within tournament range
      const cellDate = new Date(date);
      if (!this.isDateWithinTournamentRange(cellDate)) return false;
      
      // Check for existing game conflicts
      const existingGame = this.getAssignedGame(parseInt(fieldId), timeSlot, date);
      if (existingGame && existingGame.db_id !== this.draggedGame.db_id) {
        return false;
      }
      
      // Check for team time conflicts
      const conflictingGame = this.isTimeSlotOccupiedOnOtherField(
        parseInt(fieldId), timeSlot, date, this.draggedGame
      );
      
      return !conflictingGame;
    },

    // Touch end handler
    onTouchEnd(event) {
      if (!this.isDragging || !this.draggedGame) {
        this.cleanupDrag();
        return;
      }
      
      const touch = event.changedTouches[0];
      const dropTarget = this.findDropTarget(touch.clientX, touch.clientY);
      
      if (dropTarget) {
        this.handleMobileDrop(dropTarget);
      }
      
      this.cleanupDrag();
    },

    findDropTarget(x, y) {
      const elementBelow = document.elementFromPoint(x, y);
      if (!elementBelow) return null;
      
      const fieldCell = elementBelow.closest('.field-cell');
      if (!fieldCell) return null;
      
      const fieldId = fieldCell.dataset.fieldId;
      const timeSlot = fieldCell.dataset.timeSlot;
      const date = fieldCell.dataset.date;
      
      if (!fieldId || !timeSlot || !date) return null;
      
      // Find the actual field object
      const field = this.allFields.find(f => f.id === parseInt(fieldId));
      if (!field) return null;
      
      return {
        field: field,
        timeSlot: { time: timeSlot },
        date: date
      };
    },

    // Create visual preview during drag
    createDragPreview(touch) {
      const preview = document.createElement('div');
      preview.className = 'mobile-drag-preview';
      preview.innerHTML = this.getDragPreviewContent(this.draggedGame);
      
      // Enhanced styling for better visibility
      preview.style.cssText = `
        position: fixed;
        pointer-events: none;
        z-index: 10000;
        background: white;
        border: 2px solid #007bff;
        border-radius: 8px;
        padding: 12px;
        box-shadow: 0 8px 24px rgba(0,0,0,0.3);
        max-width: 250px;
        font-size: 14px;
        font-weight: 500;
        color: #333;
        transform: rotate(-5deg);
        transition: none;
      `;
      
      document.body.appendChild(preview);
      this.dragPreview = preview;
      this.updateDragPreview(touch);
    },

    // Update preview position
    updateDragPreview(touch) {
      if (!this.dragPreview) return;
      
      // Offset the preview so it doesn't hide under the finger
      const offsetX = 20;
      const offsetY = -60;
      
      this.dragPreview.style.left = (touch.clientX + offsetX) + 'px';
      this.dragPreview.style.top = (touch.clientY + offsetY) + 'px';
    },

    // Get preview content for dragged game
    getDragPreviewContent(game) {
      if (!game) return 'Moving game...';
      
      if (game.game_type === 2) {
        return `📋 ${game.game_name || "Unnamed Game"}`;
      } else {
        const team1 = game.teamA_data?.team_sr_no || "TBD";
        const team2 = game.teamB_data?.team_sr_no || "TBD";
        return `🏆 #${team1} vs #${team2}`;
      }
    },

    // Get drop target information from DOM element
    getDropTargetFromElement(fieldCell) {
      // This method needs to extract field and time slot info from the DOM
      // You'll need to add data attributes to your field cells to make this work
      const fieldId = fieldCell.dataset.fieldId;
      const timeSlot = fieldCell.dataset.timeSlot;
      const date = fieldCell.dataset.date;
      
      if (fieldId && timeSlot && date) {
        return {
          field: { id: parseInt(fieldId) },
          timeSlot: { time: timeSlot },
          date: date
        };
      }
      return null;
    },

    // Handle mobile drop
    handleMobileDrop(dropTarget) {
    const { field, timeSlot, date } = dropTarget;
    
    try {
      // Validate the drop
      if (!this.isValidDropZone(document.querySelector(`[data-field-id="${field.id}"][data-time-slot="${timeSlot.time}"][data-date="${date}"]`))) {
        return;
      }
      
      // Check for conflicts one more time
      const existingGame = this.getAssignedGame(field.id, timeSlot.time, date);
      if (existingGame && existingGame.db_id !== this.draggedGame.db_id) {
        this.showConflictAlert(existingGame, field, timeSlot, date);
        return;
      }

      const conflictingGame = this.isTimeSlotOccupiedOnOtherField(
        field.id, timeSlot.time, date, this.draggedGame
      );
      if (conflictingGame) {
        this.showOtherFieldConflictAlert(conflictingGame, field, timeSlot, date);
        return;
      }

      // Perform the assignment
      this.assignGameToSlot(this.draggedGame, field, timeSlot, date);
      this.updateGame(this.draggedGame);
      
    } catch (error) {
      console.error('Drop failed:', error);
    }
  },

  // Cleanup drag state with improved cleanup
  cleanupDrag() {
    this.isDragging = false;
    this.draggedGame = null;
    
    // Remove drag preview
    if (this.dragPreview) {
      document.body.removeChild(this.dragPreview);
      this.dragPreview = null;
    }
    
    // Reset original element styling
    if (this.originalElement) {
      this.originalElement.style.opacity = '';
      this.originalElement.style.transform = '';
      this.originalElement = null;
    }
    
    // Remove all drop zone highlights
    document.querySelectorAll('.drop-zone-highlight').forEach(el => {
      el.classList.remove('drop-zone-highlight');
    });
  },

    onRefreshBracketOnEdit() {
      this.brackets = [];
      this.getAllBrackets();
    },
    getBracketFormat(bracket) {
      return (
        bracket?.event_tournament?.bracket_format_info?.bracket_name ||
        bracket?.event_tournament?.event?.bracket_format?.bracket_name
      );
    },
    showUmpireAssignmentDiv() {
      this.AssignUmpire = true;
      this.getUmpires();
    },
    async autoAssign(index) {
      this.$set(this.isLoadingArray, index, true);
      try {
        const url = `${process.env.VUE_APP_API_URL}tournaments/autoAssignUmpires?event_id=${this.eventId}`;
        const response = await axios.post(url);
        if (response.data.statusCode === 200) {
          this.$set(this.isLoadingArray, index, false);
          this.getParkField();
          this.getEventGamesSchedule();
          this.getUmpires();
        } else if (response.data.statusCode === 404) {
          this.$alert(response.data.message, "Error");
          this.$router.push({ name: "Teams" });
          this.$set(this.isLoadingArray, index, false);
        } else {
          console.error(
            "Failed to fetch umpires:",
            response.data.message || "Unknown error occurred"
          );
          this.$set(this.isLoadingArray, index, false);
        }
      } catch (error) {
        this.$set(this.isLoadingArray, index, false);
        console.error("Failed to fetch umpires:", error);
      }
    },
    formatDateForBackend(date) {
      if (!date) return "";

      // If date is a string in format "Sat Jul 12 2025 00:00:00 GMT+0500 (Pakistan Standard Time)"
      if (typeof date === "string") {
        const d = new Date(date);
        const year = d.getFullYear();
        const month = String(d.getMonth() + 1).padStart(2, "0");
        const day = String(d.getDate()).padStart(2, "0");
        return `${year}-${month}-${day}`;
      }

      // If date is a Date object
      if (date instanceof Date) {
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, "0");
        const day = String(date.getDate()).padStart(2, "0");
        return `${year}-${month}-${day}`;
      }

      // If date is already in YYYY-MM-DD format
      return date;
    },
    async AssignUmpiresToField(umpireData, field, date) {
      try {
        // Format the date to Y-m-d
        const formattedDate = this.formatDateForBackend(date);
        const url = `${process.env.VUE_APP_API_URL
          }tournaments/assignUmpireToField?event_id=${this.eventId}&field_id=${field.id
          }&umpire_id=${umpireData.umpire_id ||
          umpireData.id}&start_date=${formattedDate}`;
        const response = await axios.post(url);
        if (response.data.statusCode === 200) {
          this.getParkField();
          this.getEventGamesSchedule();
          this.getUmpires();
          // this.$toast.success(`Umpire assigned to field ${field.field_name}`);
        } else {
          this.$alert(
            response.data.message || "Failed to assign umpire",
            "Error"
          );
        }
      } catch (error) {
        console.error("Failed to assign umpires:", error);
        this.$alert("Failed to assign umpire. Please try again.", "Error");
      }
    },
    async getUmpires(showLoader = true) {
      if (showLoader) {
        this.showUmpireListing = true;
      }
      try {
        const url = `${process.env.VUE_APP_API_URL}associationEvent/getManageUmpires?event_id=${this.eventId}&association_id=${this.association_id}`;
        const response = await axios.get(url);
        if (response.data.statusCode === 200) {
          this.availableUmpires = Object.values(response.data.data.umpires);
          this.availableUmpiresCount = this.availableUmpires.length;
          if (showLoader) {
            this.showUmpireListing = false;
          }
        } else if (response.data.statusCode === 404) {
          this.closeModal();
          this.$alert(response.data.message, "Error");
          this.$router.push({ name: "Teams" });
          if (showLoader) {
            this.showUmpireListing = false;
          }
        } else {
          console.error(
            "Failed to fetch umpires:",
            response.data.message || "Unknown error occurred"
          );
          if (showLoader) {
            this.showUmpireListing = false;
          }
        }
      } catch (error) {
        if (showLoader) {
          this.showUmpireListing = false;
        }
        console.error("Failed to fetch umpires:", error);
      }
    },
    handleAvailableClick(field, time, date, isEditing = false) {
      if (!isEditing && !this.isDateWithinTournamentRange(date)) {
        return;
      }

      this.isEditingGame = isEditing;
      const fieldId = typeof field === "object" ? field.id : field;
      const fullField =
        typeof field === "object"
          ? field
          : this.allFields.find((f) => f.id === field);

      if (!fullField) {
        console.warn("Field object not found for ID:", field);
        return;
      }

      this.selectedFieldForModal = fullField;
      this.selectedTimeForModal = time;
      this.selectedDateForModal = date;
      this.totalGames = this.teamDistributionSummary.totalGames;

      const game = this.assignedGameFor(fieldId, time, date);
      this.team1Id = game?.teamA || null;
      this.team2Id = game?.teamB || null;
      this.gameType = game?.game_type || 1;
      this.game_id = game?.db_id || null;
      this.umpireId = game?.umpire?.id || null;
      this.selectedGameName = game?.game_name || null;
      this.isEditingGame =
        (this.team1Id && this.team2Id) ||
        (this.gameType === 2 && (!this.team1Id || !this.team2Id));

      if (!game || game.division_id === this.selectedTournament.id) {
        this.callModal(this.selectedTournament);
      }
    },

    goToBracket(guid) {
      if (guid) {
        this.$router.push({ name: "BracketPlay", params: { id: guid } });
      }
    },

    getAllBrackets() {
      var formData = new FormData();
      formData.append("tournament_guid", this.selectedTournamentGuid);
      formData.append("association_id", this.association_id);

      this.showBracketLoader = 1;
      return axios
        .post(
          process.env.VUE_APP_API_URL +
          "tournaments/brackets/getTournamentBrackets",
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          }
        )
        .then((response) => {
          if (response.data.statusCode == 200) {
            this.brackets = response.data.data;
            this.showBracketLoader = 0;
          } else {
            this.showBracketLoader = 0;
          }
        });
    },

    getPoolPlayGames() {
      this.getEventGamesSchedule();
    },
    async getTournamentTeams() {
      this.tournamentTeams = [];

      try {
        const url = `${process.env.VUE_APP_API_URL}tournaments/teams/getSelectedTournamentTeams?tournament_guid=${this.selectedTournamentGuid}`;
        const response = await axios.get(url);

        if (response.data.statusCode === 200) {
          this.tournamentTeams = response.data.data.teams;
        } else if (response.data.statusCode === 404) {
          this.$alert(response.data.message, "Error");
          const elem = this.$refs.closeTournamentLineUpModal;
          if (elem) {
            elem.click();
          }
          this.$router.push({ name: "Teams" });
        } else {
          console.error("Failed to fetch teams:", response.data.message);
        }
      } catch (error) {
        console.error("Failed to fetch teams:", error);
      }
    },
    async deleteGame(game) {
      this.clickedGame = game;
      let confirmationMessage = `About to delete game ${this.clickedGame.game_name}. Continue ?`;

      if (
        this.clickedGame.teamA &&
        this.clickedGame.teamB &&
        this.clickedGame.teamA_data &&
        this.clickedGame.teamB_data &&
        this.clickedGame.teamA_data.team_name &&
        this.clickedGame.teamB_data.team_name
      ) {
        confirmationMessage = `About to delete game ${this.clickedGame.game_name} (${this.clickedGame.teamA_data.team_name} vs ${this.clickedGame.teamB_data.team_name}). Continue ?`;
      }

      this.$confirm(confirmationMessage).then(() => {
        var formData = new FormData();
        formData.append("game_id", this.clickedGame.db_id);
        formData.append("association_id", this.association_id);
        formData.append("tournament_guid", this.selectedTournamentGuid);
        let loader = this.$loading.show({
          // Optional parameters
          container: this.fullPage ? null : this.$refs.formContainer,

          color: "#ffffff",
          backgroundColor: "#333",
          opacity: 0.6,
        });

        axios
          .post(
            process.env.VUE_APP_API_URL + "tournaments/deleteTournamentGame",
            formData,
            {
              headers: {
                "Content-Type": "multipart/form-data",
              },
            }
          )
          .then((response) => {
            loader.hide();
            if (response.data.statusCode === 200) {
              // ✅ Remove the deleted game from the list
              // this.scheduleData = this.scheduleData.filter(g => g.db_id !== this.clickedGame.db_id);
              this.getEventGamesSchedule();
              loader.hide();
            } else if (response.data.statusCode === 403) {
              this.$alert(response.data.message, "Error");
              this.$router.push({ name: "Teams" });
              loader.hide();
            } else {
              this.$alert(response.data.message, "Delete game").then(() => {
                loader.hide();
              });
            }
          })
          .catch((error) => {
            console.error("An error occurred while deleting the game:", error);
            loader.hide();
          });
      });
    },

    openGameOption(game) {
      this.activeGameId = this.activeGameId === game.db_id ? null : game.db_id;
    },

    onClickOutside() {
      this.activeGameId = null;
    },

    assignedGameFor(fieldId, time, date) {
      return this.getAssignedGame(
        fieldId,
        time,
        this.getDateForComparison(date)
      );
    },

    assignColorsToDivisions() {
      const staticColors = ["#DFFFEA", "#FFFAEA"]; // greenish, bluish
      const usedColors = new Set(staticColors);
      const uniqueDivisions = [
        ...new Set(this.scheduleData.map((game) => game.division)),
      ];

      uniqueDivisions.forEach((division, index) => {
        if (!this.divisionColorMap[division]) {
          if (index < staticColors.length) {
            this.divisionColorMap[division] = staticColors[index];
          } else {
            let newColor;
            do {
              newColor = this.getRandomPastelColor();
            } while (usedColors.has(newColor)); // avoid duplicates

            usedColors.add(newColor);
            this.divisionColorMap[division] = newColor;
          }
        }
      });
    },
    getRandomPastelColor() {
      const hue = Math.floor(Math.random() * 360);
      return `hsl(${hue}, 70%, 85%)`; // pastel-like
    },
    getDivisionStyle(division) {
      const color = this.divisionColorMap[division];
      return color ? { backgroundColor: color } : {};
    },
    getDivisionColorStyle(divisionName) {
      const color = this.divisionColorMap[divisionName] || "#f0f0f0";
      return {
        backgroundColor: color,
        borderLeft: "4px solid #999",
      };
    },
    callModal(selectedTournament) {
      var tournament = selectedTournament.guid;
      this.$root.$emit("openTournamentAddGameModal", tournament);
    },

    getAssignedGame(fieldId, time, date) {
      const key = `${fieldId}-${time}-${date}`;
      return this.assignedGamesMap[key] || null;
    },

    // Updated method: Check if this time slot is occupied on another field with same teams
    isTimeSlotOccupiedOnOtherField(fieldId, time, date, currentGame) {
      for (const assignment of this.fieldAssignments) {
        if (
          assignment.fieldId !== fieldId && // different field
          assignment.time === time &&
          assignment.date === date
        ) {
          // Check if either team from current game is playing in the other assignment
          const otherGame = assignment.game;
          if (
            currentGame.db_id !== otherGame.db_id && // not the same game
            (currentGame.teamA === otherGame.teamA ||
              currentGame.teamA === otherGame.teamB ||
              currentGame.teamB === otherGame.teamA ||
              currentGame.teamB === otherGame.teamB)
          ) {
            return assignment.game;
          }
        }
      }
      return null;
    },

    onDragStart(game, event) {
      this.draggedGame = game;
      this.isDragging = true;
      if (event.dataTransfer) {
        event.dataTransfer.setData("game", JSON.stringify(game));
        event.dataTransfer.effectAllowed = "move";
      }
    },

    onDragStartUmpire(umpire, event) {
      this.draggedUmpire = umpire;
      event.dataTransfer.setData("umpire", JSON.stringify(umpire));
    },

    onDrop(field, timeSlot, date, event) {
      event.preventDefault();
      const gameData =
        this.draggedGame || JSON.parse(event.dataTransfer.getData("game"));
      if (!gameData) return;

      const formattedDate = this.getDateForComparison(date);

      // 1️⃣ Check if the slot is occupied on the SAME field
      const existingGame = this.getAssignedGame(
        field.id,
        timeSlot.time,
        formattedDate
      );
      if (existingGame && existingGame.db_id !== gameData.db_id) {
        this.showConflictAlert(existingGame, field, timeSlot, formattedDate);
        return;
      }

      // 2️⃣ Check if the same team is playing at same time on another field
      const conflictingGame = this.isTimeSlotOccupiedOnOtherField(
        field.id,
        timeSlot.time,
        formattedDate,
        gameData
      );
      if (conflictingGame) {
        this.showOtherFieldConflictAlert(
          conflictingGame,
          field,
          timeSlot,
          formattedDate
        );
        return;
      }

      this.assignGameToSlot(gameData, field, timeSlot, formattedDate);
      this.updateGame(gameData); // <--- Only called for the dropped game
    },

    onFieldDrop(field, timeSlot, date, event) {
      event.preventDefault();
      const umpireData =
        this.draggedUmpire || JSON.parse(event.dataTransfer.getData("umpire"));
      if (!umpireData) return;

      this.AssignUmpiresToField(umpireData, field, date);
    },

    assignGameToSlot(game, field, timeSlot, date) {
      const assignedIndex = this.scheduleData.findIndex(
        (g) => g.db_id === game.db_id
      );
      if (assignedIndex !== -1) {
        this.unlinkGameFromPreviousSlot(game);

        const originalGame = this.scheduleData[assignedIndex];
        this.$set(originalGame, "assignedFieldId", field.id);
        this.$set(originalGame, "assignedFieldName", field.field_name);
        this.$set(originalGame, "assignedTime", timeSlot.time);
        this.$set(originalGame, "assignedDate", date);

        this.fieldAssignments = this.fieldAssignments.filter(
          (assignment) => assignment.game.db_id !== game.db_id
        );

        this.fieldAssignments.push({
          fieldId: field.id,
          fieldName: field.field_name,
          time: timeSlot.time,
          date: date,
          game: game,
        });

        this.$forceUpdate();
      } else {
        console.warn("Game not found in scheduleData");
      }
    },

    unlinkGameFromPreviousSlot(game) {
      this.fieldAssignments = this.fieldAssignments.filter(
        (assignment) => assignment.game.db_id !== game.db_id
      );
    },

    async unlinkGame(game) {
      if (!game) {
        console.warn("Tried to unlink a null game!");
        return;
      }

      const message = `Unlink this game?\n\n${game?.teamA_data?.team_name} vs ${game?.teamB_data?.team_name}`;

      try {
        await this.$confirm(message, "Confirm Unlink", {
          confirmButtonText: "Unlink",
          cancelButtonText: "Cancel",
          type: "warning",
        });

        const gameIndex = this.scheduleData.findIndex(
          (g) => g.db_id === game.db_id
        );
        if (gameIndex !== -1) {
          const gameToUnlink = this.scheduleData[gameIndex];

          this.$delete(gameToUnlink, "assignedFieldId");
          this.$delete(gameToUnlink, "assignedFieldName");
          this.$delete(gameToUnlink, "assignedTime");
          this.$delete(gameToUnlink, "assignedDate");

          gameToUnlink.unlink = true;

          await this.updateGame(gameToUnlink);

          this.fieldAssignments = this.fieldAssignments.filter(
            (assignment) => assignment.game.db_id !== game.db_id
          );

          this.$forceUpdate();
        }
      } catch (err) {
        // This block runs if user cancels or an error occurs
        console.log("Unlink canceled or error occurred", err);
      }
    },

    showConflictAlert(existingGame, field, timeSlot, date) {
      const message = `This slot is already occupied!\n\nExisting Game:\n${existingGame.teamA_data.team_name} vs ${existingGame.teamB_data.team_name}\nDivision: ${existingGame.division}\nField: ${field.field_name}\nTime: ${timeSlot.time} - ${date}\n\nPlease choose a different slot.`;
      this.$alert(message);
    },

    showOtherFieldConflictAlert(existingGame, field, timeSlot, date) {
      const formattedDateTime = this.formatDateTime(date, timeSlot.time);
      const fieldName = existingGame.assignedFieldName || "N/A";
      const message = `One of the teams is already playing at this time on another field!\n\nExisting Game:\n${existingGame.teamA_data.team_name} vs ${existingGame.teamB_data.team_name}\nDivision: ${existingGame.division}\nField: ${fieldName}\nTime: ${formattedDateTime}\n\nA team cannot play on multiple fields at the same time.`;
      this.$alert(message);
    },

    getDateForComparison(date) {
      if (date instanceof Date) {
        // Use local time instead of UTC
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, "0");
        const day = String(date.getDate()).padStart(2, "0");
        return `${year}-${month}-${day}`;
      }
      return date;
    },

    debugAssignedGames() {
      const assigned = this.scheduleData.filter((game) => game.assignedFieldId);
      if (assigned.length > 0) {
        console.table(
          assigned.map((g) => ({
            teams: `${g.teamA_data.team_name} vs ${g.teamB_data.team_name}`,
            field: g.assignedFieldName,
            time: g.assignedTime,
            date: g.assignedDate,
          }))
        );
      }
    },

    removeField(fieldToRemove) {
      this.selectedFields = this.selectedFields.filter(
        (field) => field.id !== fieldToRemove.id
      );
    },
    generateTimeSlots(startTime, intervalMinutes, endTime) {
      const slots = [];

      // Helper function to convert "HH:MM AM/PM" → total minutes
      const convertToMinutes = (timeStr) => {
        const [time, period] = timeStr.split(" ");
        const [hours, minutes] = time.split(":").map(Number);

        let hour24 = hours;
        if (period === "PM" && hours !== 12) hour24 += 12;
        if (period === "AM" && hours === 12) hour24 = 0;

        return hour24 * 60 + minutes;
      };

      const startMinutes = convertToMinutes(startTime);
      const endMinutes = convertToMinutes(endTime); // ⬅️ using dynamic endTime

      for (
        let currentMinutes = startMinutes;
        currentMinutes < endMinutes;
        currentMinutes += intervalMinutes
      ) {
        const hour = Math.floor(currentMinutes / 60);
        const minute = currentMinutes % 60;

        const displayHour = hour > 12 ? hour - 12 : hour === 0 ? 12 : hour;
        const displayPeriod = hour >= 12 ? "PM" : "AM";
        const timeString = `${displayHour
          .toString()
          .padStart(2, "0")}:${minute
            .toString()
            .padStart(2, "0")} ${displayPeriod}`;

        slots.push({
          time: timeString,
          minutes: currentMinutes,
        });
      }

      return slots;
    },

    formatTableDate(date) {
      const options = {
        weekday: "long",
        year: "numeric",
        month: "long",
        day: "numeric",
      };
      return date.toLocaleDateString("en-US", options);
    },
    handleBackClick() {
      // this.scheduleData = [];
      this.tournamentSelected = false;
    },
    handleBackClickFromUmpire() {
      this.AssignUmpire = false;
    },
    goEventListing() {
      const eventId = this.$route.params.id;
      this.$router.push({
        name: "AssociationSingleEventDetail",
        params: { id: eventId },
      });
    },
    formatDateTime(date, time) {
      if (!date || !time) return "";
      const [year, month, day] = date.split("-");
      const months = [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec",
      ];
      const monthName = months[parseInt(month, 10) - 1]; // months are 0-indexed
      return `${day} ${monthName}, ${year} ${time}`;
    },
    async generatePoolPlay() {
      this.poolLoader = true;
      const selectedFieldsToSend = this.selectedFields
        ? this.parkField.map((f) => f.id)
        : this.allFields.map((f) => f.id);

      // Prepare the payload
      const payload = {
        tournament_guid: this.selectedTournamentGuid, // Use correct GUID
        startTime: this.startTime,
        endTime: this.endTime,
        gameDuration: this.tournament_time,
        maxGamesPerTeam: this.gamesPerTeam,
        maxGamesPerField: this.gamesPerField,
        selectedFields: selectedFieldsToSend,
        avoidRematches: this.avoidRematches,
        avoidBackToBackGames: this.avoidBackToBackGames,
        eventGuid: this.getEventGuidFromUrl(),
      };

      this.isGenerating = true;

      try {
        const formData = new FormData();

        // Append all fields to FormData
        for (const key in payload) {
          if (Array.isArray(payload[key])) {
            // Send arrays as JSON strings
            formData.append(key, JSON.stringify(payload[key]));
          } else {
            formData.append(key, payload[key]);
          }
        }

        const response = await axios.post(
          `${process.env.VUE_APP_API_URL}tournaments/generateDivisionPoolSchedule`,
          formData
        );

        if (response.data.statusCode === 200) {
          // this.$alert('Pool play generated successfully!', 'Success');
          this.scheduled = response.data.data;

          if (response.data.data && response.data.data.schedule) {
            // Step 1: Get existing game IDs (adjust field name if different)
            const existingGameIds = new Set(
              this.scheduleData.map((game) => game.db_id)
            ); // or game.game_guid

            // Step 2: Filter out games already in scheduleData
            const newGames = response.data.data.schedule.filter(
              (game) => !existingGameIds.has(game.db_id) // or game.game_guid
            );

            // Step 3: Add only new games
            this.scheduleData = [...this.scheduleData, ...newGames];

            this.assignColorsToDivisions();
            this.summaryData = response.data.data.summary;
            this.tournamentSelected = true;
          }

          this.$root.$emit("poolPlayGenerated", response.data.data);
        } else {
          this.$alert(
            response.data.message || "Failed to generate pool play",
            "Error"
          );
        }
      } catch (error) {
        console.error("Error generating pool play:", error);
        this.$alert("Failed to generate pool play. Please try again.", "Error");
      } finally {
        this.isGenerating = false;
        this.poolLoader = false;
      }
    },


    getParkField(searchQuery, showLoader = true) {
      if (showLoader) {
        this.showFieldsLoader = 1;
      }
      axios
        .get(
          `${process.env.VUE_APP_API_URL}getAllEventParkFields?event_id=${this.eventId
          }&search=${searchQuery || ""}`
        )
        .then((response) => {
          const parks = response.data.data.parks || [];

          // Flatten all fields and filter out "Add field"
          const allFields = parks
            .flatMap((park) => park.fields || [])
            .filter(
              (field) =>
                field.field_name &&
                field.field_name.toLowerCase() !== "add field"
            );

          this.allFields = allFields;
          this.selectedFields = [...allFields];
          // this.isLoadingField = false;
          if (showLoader) {
            this.showFieldsLoader = 0;
          }
          // this.scrollToDivisionStartDate();
        });
    },

    checkParkField: function () {
      this.getParkField();
    },

    getEventGuidFromUrl() {
      const url = window.location.pathname;
      const segments = url.split("/");
      return segments.pop();
    },
    startEdit(rowId, field, currentValue) {
      this.editingCell = rowId + "-" + field;
      this.editValue = currentValue;
      this.$nextTick(() => {
        if (this.$refs.editInput && this.$refs.editInput.length > 0) {
          this.$refs.editInput[0].focus();
        }
      });
    },
    addBracket() {
      const bracketData = {
        // If 'Custom Team Selection' is on, send only selected teams. Otherwise, send all teams.
        tournamentTeams: this.tournamentTeams,
        selectedTournamentName: this.selectedTournamentName,
        selectedTournamentGuid: this.selectedTournamentGuid,
      };

      // 3. As requested, emit the data object on the global event bus
      // Any component listening for 'createBracketFromModal' will receive this data.
      this.$root.$emit("openAddBracketModal", bracketData);
    },
    saveEdit(rowId, field) {
      const rowIndex = this.scheduleData.findIndex((row) => row.id === rowId);
      if (rowIndex !== -1) {
        this.$set(this.scheduleData[rowIndex], field, this.editValue);
      }
      this.editingCell = null;
      this.editValue = "";
    },
    formatDateRange(startDate, endDate) {
      const start = new Date(startDate);
      const end = new Date(endDate);

      const startDateString = start.toLocaleDateString("en-US", {
        month: "short",
        day: "numeric",
      });
      const endDateString = end.toLocaleDateString("en-US", {
        month: "short",
        day: "numeric",
      });
      const startYear = start.getFullYear();
      const endYear = end.getFullYear();

      if (startYear === endYear) {
        return `${startDateString} to ${endDateString}, ${startYear}`;
      } else {
        return `${startDateString}, ${startYear} to ${endDateString}, ${endYear}`;
      }
    },
    formatAssignedDate(date) {
      if (!date) return "";

      const d = new Date(date);

      const monthNames = [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December",
      ];

      const month = monthNames[d.getMonth()]; // getMonth() returns 0-based month
      const day = d.getDate(); // getDate() returns day of the month
      const year = d.getFullYear();

      return `${month} ${day}, ${year}`;
    },
    cancelEdit() {
      this.editingCell = null;
      this.editValue = "";
    },
    async TournamentsDetailData() {
      var url = window.location.pathname;
      var segment_array = url.split("/");
      var eventGuid = segment_array.pop();
      this.showEventHeadingLoader = 1;
      this.showLoaderTournament = 1;

      try {
        const response = await axios.post(
          `${process.env.VUE_APP_API_URL}event/tournamentListForAdminEvents?page=${this.divisionPage}`,
          { event_guid: eventGuid }
        );

        if (response.data.statusCode === 200) {
          const tournamentResponse = response.data.data.eventTournaments.data;
          this.events = response.data.data.teamEventData;
          this.allDay = response.data.data.teamEventData.allDay;
          this.startDate = response.data.data.teamEventData.exactStartDate;
          this.endDate = response.data.data.teamEventData.exactEndDate;
          this.eventId = response.data.data.teamEventData.id;
          this.eventName = response.data.data.teamEventData.eventName;
          this.startTime = this.allDay === "true" ? "12:00 AM" : response.data.data.teamEventData.exactStartTime;
          this.endTime = this.allDay === "true" ? "11:59 PM" : response.data.data.teamEventData.exactEndTime;
          this.tournament_time = Number(
            response.data.data.teamEventData?.time_interval ?? 30
          );
          this.association_id =
            response.data.data?.user_association_role?.association_id;
          this.divisionlastPage = response.data.data.eventTournaments.last_page;

          if (this.divisionPage > 1) {
            const combined = [...this.tournamentsData, ...tournamentResponse];

            // Filter unique by `guid`
            const uniqueTournaments = combined.filter(
              (tournament, index, self) =>
                index === self.findIndex((t) => t.guid === tournament.guid)
            );

            this.tournamentsData = uniqueTournaments;
          } else {
            this.tournamentsData = tournamentResponse;
          }

          this.$nextTick(() => {
            if (
              this.sortedTournaments.length > 0 &&
              !this.selectedTournamentGuid
            ) {
              const firstSortedTournament = this.sortedTournaments[0];
              this.selectTournament(firstSortedTournament);
            }
          });
        } else if (response.data.statusCode === 404) {
          this.$alert(response.data.message, "Error");
          this.$router.push({ name: "Teams" });

          this.showLoader = 0; // Hide loader
        } else {
          this.errorMessage = response.data.message || "Unknown error occurred";
          this.showLoaderTournament = 0;
        }
      } catch (error) {
        this.errorMessage = "Failed to fetch data";
        this.showLoaderTournament = 0;
      } finally {
        this.isTournamentLoading = false;
        this.showEventHeadingLoader = 0;
        this.showLoaderTournament = 0;
        this.$root.$emit("divisionPaginationLoaded");
      }
    },

    async getEventGamesSchedule(showLoader = true) {
      var url = window.location.pathname;
      var segment_array = url.split("/");
      var eventGuid = segment_array.pop();

      if (showLoader) {
        this.showEventHeadingLoader = 1;
      }

      try {
        const response = await axios.get(
          `${process.env.VUE_APP_API_URL}tournaments/getEventGamesSchedule`,
          { params: { event_guid: eventGuid } }
        );

        if (response.data.statusCode === 200) {
          this.scheduleData = response.data.data.schedule;
          this.summaryData = response.data.data.summary;

          this.totalGamesForUmpire = response.data.data.summary.totalGames;
          this.poolNonUmpireGames =
            response.data.data.umpireStats.pool_game_without_umpire;
          this.bracketNonUmpireGames =
            response.data.data.umpireStats.bracket_game_without_umpire;

          // Assign each game to its slot
          this.scheduleData.forEach((game) => {
            if (
              game.assignedFieldId &&
              game.assignedTime &&
              game.assignedDate
            ) {
              const field = {
                id: game.assignedFieldId,
                field_name: game.assignedFieldName,
              };

              const timeSlot = {
                time: game.assignedTime,
              };

              this.assignGameToSlot(game, field, timeSlot, game.assignedDate);
            }
          });
          this.assignColorsToDivisions();
        }
      } catch (error) {
        this.errorMessage = "Failed to fetch data";
      } finally {
        this.$root.$emit("divisionPaginationLoaded");
        if (showLoader) {
          this.showEventHeadingLoader = 0;
        }
      }
    },
    toggleDropdown() {
      this.searchQuery = "";
      this.activeDropdown = !this.activeDropdown;

      this.$nextTick(() => {
        if (this.activeDropdown && this.$refs.dropdownMenu) {
          this.$refs.dropdownMenu.addEventListener(
            "scroll",
            this.onDropdownScroll
          );
        } else if (this.$refs.dropdownMenu) {
          this.$refs.dropdownMenu.removeEventListener(
            "scroll",
            this.onDropdownScroll
          );
        }
      });
    },
    onDropdownScroll() {
      this.handleDivisionPagination();
    },

    handleDivisionPagination() {
      if (this.divisionPage <= this.divisionlastPage) {
        this.divisionPage++;
        this.TournamentsDetailData();
      }
    },
    closeDropdown() {
      this.activeDropdown = false;
    },
    scrollToDivisionStartDate() {
      if (
        !this.selectedTournament ||
        !this.selectedTournament.startDateForField
      )
        return;

      const startDate = this.selectedTournament.startDateForField; // e.g., "2025-06-12"
      const refName = "table-" + startDate;

      // Vue 2: v-for with ref returns an array
      setTimeout(() => {
        const ref = this.$refs[refName];
        const targetTable = Array.isArray(ref) ? ref[0] : ref;

        if (targetTable && typeof targetTable.scrollIntoView === "function") {
          targetTable.scrollIntoView({
            behavior: "smooth",
            block: "nearest",
            inline: "start",
          });
        } else {
          console.warn("scrollIntoView failed", targetTable);
        }
      }, 100);
    },
    selectTournament(tournament) {
      this.selectedTournamentGuid = tournament.guid;
      this.selectedTournament = tournament;
      this.closeDropdown();
      this.$nextTick(() => {
        this.scrollToDivisionStartDate();
      });
      this.getAllBrackets();
      this.getTournamentTeams();
    },
    isDateWithinTournamentRange(date) {
      if (!this.selectedTournament) return false;

      const start = new Date(this.selectedTournament.startDateForField);
      const end = new Date(this.selectedTournament.endDateForField);

      const cellDate = new Date(date);

      // Remove time part for comparison
      start.setHours(0, 0, 0, 0);
      end.setHours(0, 0, 0, 0);
      cellDate.setHours(0, 0, 0, 0);

      return cellDate >= start && cellDate <= end;
    },

    isUmpireAssignedElsewhere(umpireId, time, date, currentGameId) {
      // Loop through all games to see if this umpire is assigned elsewhere at same time
      return this.allGames.some((game) => {
        return (
          game.umpire?.id === umpireId &&
          game.time === time &&
          this.getDateForComparison(game.date) === date &&
          game.db_id !== currentGameId
        );
      });
    },

    async handleUmpireDrop(field, timeSlot, date, umpireData) {
      const formattedDate = this.getDateForComparison(date);
      const game = this.getAssignedGame(field.id, timeSlot.time, formattedDate);

      if (!game) {
        this.$alert("No game assigned to this slot to assign umpire to.");
        return;
      }

      // Check for scheduling conflicts
      const conflict = this.scheduleData.find((g) => {
        return (
          g.umpire?.id === umpireData.umpire_id &&
          g.assignedTime === timeSlot.time &&
          this.getDateForComparison(g.assignedDate) === formattedDate &&
          g.db_id !== game.db_id
        );
      });

      if (conflict) {
        this.$alert(`This umpire is already assigned to:
                ${conflict.teamA_data?.team_name || "TBD"} vs ${conflict
            .teamB_data?.team_name || "TBD"}
                at the same time`);
        return;
      }

      // Prepare the update
      const gameToUpdate = {
        ...game,
        umpire: umpireData,
        umpire_id: umpireData.umpire_id,
      };

      // Use existing update method
      const success = await this.updateGame(gameToUpdate);

      if (success) {
        this.$toast.success(`Assigned ${umpireData.name} to game`);
      }
    },

    handleDrop(field, timeSlot, date, event) {
      try {
        const umpireData = JSON.parse(event.dataTransfer.getData("umpire"));
        if (umpireData) {
          this.handleUmpireDrop(field, timeSlot, date, umpireData);
          return;
        }
      } catch (e) {
        // Not umpire data, continue with game drop
      }

      if (!this.isDateWithinTournamentRange(date)) {
        // Optionally show alert or toast
        // this.$alert("Cannot drop games on invalid date.");
        return;
      }

      this.onDrop(field, timeSlot, date, event);
    },

    handleDropOnField(field, timeSlot, date, event) {
      try {
        const umpireData =
          this.draggedUmpire ||
          JSON.parse(event.dataTransfer.getData("umpire"));
        if (umpireData) {
          this.AssignUmpiresToField(umpireData, field, date);
          return;
        }
      } catch (e) {
        // Not umpire data, continue with game drop
      }

      // Handle game drop if no umpire data
      const gameData =
        this.draggedGame || JSON.parse(event.dataTransfer.getData("game"));
      if (gameData) {
        this.onDrop(field, timeSlot || { time: "" }, date, event);
      }
    },

    async updateGame(game) {
      // Start the loader and disable the game controls
      this.showLoaderGame = true;
      this.isDisabledGame = true;

      const formData = new FormData();
      if (game?.teamA) {
        formData.append("team_1_id", game.teamA);
      }

      if (game?.teamB) {
        formData.append("team_2_id", game.teamB);
      }
      formData.append("event_id", this.selectedTournament?.event_id);
      formData.append("game_type", game?.game_type);

      if (game.unlink) {
        formData.append("start_date", "");
        formData.append("start_time", "");
        formData.append("field_id", "");
      } else {
        formData.append("start_date", game?.assignedDate);
        formData.append("start_time", game?.assignedTime);
        formData.append("field_id", game?.assignedFieldId);
      }

      // Umpire assignment
      if (typeof game.umpire_id !== 'undefined' && game.umpire_id !== null) {
        formData.append("umpire_id", game.umpire_id);
      } else {
        // Explicitly remove umpire
        formData.append("umpire_id", "");
      }


      if (game && game.db_id) {
        formData.append("game_id", game.db_id);
      } else {
        console.error("No game ID found to update!");
        this.showLoaderGame = false;
        this.isDisabledGame = false;
        return;
      }

      try {
        const response = await axios.post(
          `${process.env.VUE_APP_API_URL}tournaments/editTournamentGame`,
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          }
        );

        console.log("game updated successfully", response);

        // ✅ Remove unlink from game object
        if (Object.prototype.hasOwnProperty.call(game, "unlink")) {
          delete game.unlink;
        }

        // Optionally emit or refresh things here
        this.$root.$emit("RefreshTournamentGames");
        this.$emit("RefreshPoolPlayGames");
        this.getEventGamesSchedule(false);
        this.getParkField(null, false);
        this.getUmpires(false);
      } catch (error) {
        console.error("Error updating game", error);
      } finally {
        this.showLoaderGame = false;
        this.isDisabledGame = false;
      }
    },
    onTouchStartUmpire(umpire, event) {
      this.draggedUmpire = umpire;
      this.isDragging = false;
      
      const touch = event.touches[0];
      this.touchStartPos = {
        x: touch.clientX,
        y: touch.clientY
      };
      
      // Store the original element for reference
      this.originalElement = event.currentTarget;
      
      // Add visual feedback
      if (this.originalElement) {
        this.originalElement.style.opacity = '0.7';
        this.originalElement.style.transform = 'scale(0.95)';
      }
      
      event.preventDefault();
    },

    // Touch move handler for umpire
    onTouchMoveUmpire(event) {
      if (!this.draggedUmpire) return;
      
      const touch = event.touches[0];
      const deltaX = Math.abs(touch.clientX - this.touchStartPos.x);
      const deltaY = Math.abs(touch.clientY - this.touchStartPos.y);
      
      // Start dragging if moved more than 10px
      if (!this.isDragging && (deltaX > 10 || deltaY > 10)) {
        this.isDragging = true;
        this.createUmpireDragPreview(touch);
      }
      
      if (this.isDragging) {
        this.updateDragPreview(touch);
        this.highlightUmpireDropZones(touch);
        event.preventDefault();
      }
    },

    // Touch end handler for umpire
    onTouchEndUmpire(event) {
      if (!this.isDragging || !this.draggedUmpire) {
        this.cleanupDrag();
        return;
      }
      
      const touch = event.changedTouches[0];
      const dropTarget = this.findUmpireDropTarget(touch.clientX, touch.clientY);
      
      if (dropTarget) {
        this.handleUmpireMobileDrop(dropTarget);
      }
      
      this.cleanupDrag();
    },

    // Create umpire-specific drag preview
    createUmpireDragPreview(touch) {
      const preview = document.createElement('div');
      preview.className = 'mobile-drag-preview umpire-preview';
      preview.innerHTML = `👨‍⚖️ ${this.draggedUmpire?.umpire?.name || "Umpire"}`;
      
      preview.style.cssText = `
        position: fixed;
        pointer-events: none;
        z-index: 10000;
        background: white;
        border: 2px solid #007bff;
        border-radius: 8px;
        padding: 12px;
        box-shadow: 0 8px 24px rgba(0,0,0,0.3);
        max-width: 250px;
        font-size: 14px;
        font-weight: 500;
        color: #333;
        transform: rotate(-5deg);
        transition: none;
      `;
      
      document.body.appendChild(preview);
      this.dragPreview = preview;
      this.updateDragPreview(touch);
    },

    // Find umpire drop target
    findUmpireDropTarget(x, y) {
      const elementBelow = document.elementFromPoint(x, y);
      if (!elementBelow) return null;
      
      // Check if dropped on a field header
      const fieldHeader = elementBelow.closest('.field-header');
      if (fieldHeader) {
        const fieldId = fieldHeader.dataset.fieldId;
        const field = this.allFields.find(f => f.id === parseInt(fieldId));
        if (field) {
          return { field, assignToField: true };
        }
      }
      
      // Check if dropped on a game cell
      const fieldCell = elementBelow.closest('.field-cell');
      if (fieldCell) {
        const fieldId = fieldCell.dataset.fieldId;
        const timeSlot = fieldCell.dataset.timeSlot;
        const date = fieldCell.dataset.date;
        
        if (fieldId && timeSlot && date) {
          const field = this.allFields.find(f => f.id === parseInt(fieldId));
          return {
            field,
            timeSlot: { time: timeSlot },
            date,
            assignToField: false
          };
        }
      }
      
      return null;
    },

    // Highlight potential umpire drop zones
    highlightUmpireDropZones(touch) {
      // Remove previous highlights
      document.querySelectorAll('.umpire-drop-zone-highlight').forEach(el => {
        el.classList.remove('umpire-drop-zone-highlight');
      });
      
      // Find and highlight current drop zone
      const elementBelow = document.elementFromPoint(touch.clientX, touch.clientY);
      if (elementBelow) {
        // Highlight field headers
        const fieldHeader = elementBelow.closest('.field-header');
        if (fieldHeader) {
          fieldHeader.classList.add('umpire-drop-zone-highlight');
          return;
        }
        
        // Highlight game cells
        const fieldCell = elementBelow.closest('.field-cell');
        if (fieldCell && this.isValidUmpireDropZone(fieldCell)) {
          fieldCell.classList.add('umpire-drop-zone-highlight');
        }
      }
    },

    // Validate umpire drop zone
    isValidUmpireDropZone(dropZoneElement) {
      // For field headers (assign to all games on field)
      if (dropZoneElement.classList.contains('field-header')) {
        return true;
      }
      
      // For game cells
      const fieldId = dropZoneElement.dataset.fieldId;
      const timeSlot = dropZoneElement.dataset.timeSlot;
      const date = dropZoneElement.dataset.date;
      
      if (!fieldId || !timeSlot || !date) return false;
      
      // Check if there's a game to assign umpire to
      const existingGame = this.getAssignedGame(parseInt(fieldId), timeSlot, date);
      return !!existingGame;
    },

    // Handle umpire drop on mobile
    handleUmpireMobileDrop(dropTarget) {
      if (!this.draggedUmpire) return;
      
      try {
        if (dropTarget.assignToField) {
          // Assign to all games on this field
          this.AssignUmpiresToField(this.draggedUmpire, dropTarget.field, null);
        } else {
          // Assign to specific game slot
          const { field, timeSlot, date } = dropTarget;
          const game = this.getAssignedGame(field.id, timeSlot.time, date);
          
          if (game) {
            const gameToUpdate = {
              ...game,
              umpire: this.draggedUmpire,
              umpire_id: this.draggedUmpire.umpire_id || this.draggedUmpire.id
            };
            
            this.updateGame(gameToUpdate);
          }
        }
      } catch (error) {
        console.error('Umpire drop failed:', error);
      }
    },
  },
  async mounted() {
    await this.TournamentsDetailData();
    await this.getEventGamesSchedule();
    this.getAllBrackets();
    await this.getParkField();
    this.getTournamentTeams();

    if (this.$route.query.view === 'umpire') {
      this.showUmpireAssignmentDiv();
    }

    this.$root.$on("refreshBracket", () => {
      this.brackets = [];
      this.getAllBrackets();
    });
  },
};
</script>

<style scoped>
.field-selector-container {
  width: 100%;
  max-width: 400px;
}

.fields-configuration {
  padding: 16px 0;
}

.configuration-title {
  font-size: 14px;
  font-weight: 500;
  color: #374151;
  margin-bottom: 8px;
}

.selected-fields-list {
  margin-bottom: 16px;
}

.field-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: #f3f4f6;
  border: 1px solid #d1d5db;
  border-radius: 6px;
  padding: 8px 12px;
  margin-bottom: 8px;
}

.field-name {
  font-size: 14px;
  color: #374151;
}

.remove-button {
  background: none;
  border: none;
  cursor: pointer;
  padding: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  transition: background-color 0.2s;
  font-size: 12px;
}

.remove-button:hover {
  background-color: #fee2e2;
}

.dropdown-container {
  position: relative;
}

.dropdown-trigger {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: white;
  border: 1px solid #d1d5db;
  border-radius: 6px;
  padding: 8px 12px;
  cursor: pointer;
  transition: border-color 0.2s;
}

.dropdown-trigger:hover {
  border-color: #9ca3af;
}

.dropdown-trigger:focus {
  outline: none;
  border-color: #3b82f6;
  box-shadow: 0 0 0 2px rgba(59, 130, 246, 0.5);
}

.dropdown-placeholder {
  font-size: 14px;
  color: #6b7280;
}

.dropdown-arrow {
  width: 16px;
  height: 16px;
  transition: transform 0.2s;
}

.dropdown-arrow.rotated {
  transform: rotate(180deg);
}

.dropdown-menu {
  position: absolute;
  z-index: 10;
  width: 100%;
  margin-top: 4px;
  background-color: white;
  border: 1px solid #d1d5db;
  border-radius: 6px;
  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1);
}

.search-container {
  padding: 8px;
  border-bottom: 1px solid #e5e7eb;
}

.search-input {
  width: 100%;
  padding: 8px 12px;
  font-size: 14px;
  border: 1px solid #d1d5db;
  border-radius: 4px;
  outline: none;
}

.search-input:focus {
  border-color: #3b82f6;
  box-shadow: 0 0 0 2px rgba(59, 130, 246, 0.5);
}

.options-list {
  max-height: 200px;
  overflow-y: auto;
}

.option-item {
  width: 100%;
  text-align: left;
  padding: 8px 12px;
  font-size: 14px;
  color: #374151;
  background: none;
  border: none;
  cursor: pointer;
  transition: background-color 0.2s;
}

.option-item:hover {
  background-color: #f3f4f6;
}

.option-item:focus {
  outline: none;
  background-color: #f3f4f6;
}

.loading-state,
.no-results {
  padding: 8px 12px;
  font-size: 14px;
  color: #6b7280;
  text-align: center;
}

.drag-handle {
  font-size: 20px;
  user-select: none;
}

/* Field Cell Styles */
.field-cell {
  position: relative;
  vertical-align: top;
  min-height: 60px;
  padding: 8px;
}

.availability-status.available {
  color: #6c757d;
  cursor: pointer;
  min-height: 80px;
  display: flex;
  align-items: center;
  justify-content: center;
}

/* Drag over effects */
.field-cell:hover {
  background-color: #f8f9fa;
}

.field-cell.drag-over {
  background-color: #fff3cd;
  border: 2px dashed #ffc107;
}

/* Enhanced assigned info in game cards */
.assigned-info {
  background-color: #f0f2f5;
  border: 0.5px solid #cfd7e0;
  border-radius: 5px;
  padding: 10px;
  margin-top: 8px;
  display: flex;
  align-items: baseline;
  justify-content: space-between;
}

.assigned-info .btn {
  margin-top: 5px;
  font-size: 11px;
  padding: 2px 8px;
}

.availability-status.invalid {
  /* font-style: italic; */
  padding: 15px 10px;
}

.field-cell.no-game,
.field-cell.invalid {
  background-color: #f0f2f5;
  cursor: not-allowed;
}

/* Responsive adjustments */
@media (max-width: 768px) {
  .unlink-btn {
    width: 20px;
    height: 20px;
    font-size: 8px;
  }

  .game-info {
    padding-right: 25px;
  }

  .teams {
    font-size: 12px;
  }
}

.pool-table-container {
  width: 100%;
  overflow-x: auto;
}

.pool-table-container table {
  width: 100%;
  border-collapse: collapse;
  table-layout: auto;
  /* Let columns grow/shrink as needed */
  min-width: 100%;
  /* Ensures table doesn't shrink too much */
}

.pool-table-container th,
.pool-table-container td {
  text-align: center;
  vertical-align: middle;
  padding: 8px;
  border: 0.5px solid #b9c6d3;
  min-width: 50px;
  /* Each column has at least 250px width */
  white-space: nowrap;
  /* Prevents text from wrapping */
}

.pool-table-container th {
  background-color: #cfd7e0;
  font-weight: 400;
  color: #254c72;
  font-size: 14px;
  height: 60px;
}

.pool-table-container td {
  background-color: #ffffff;
  font-size: 12px;
  font-weight: 400;
  color: #869cb1;
  min-width: 90px;
}

@media (max-width: 768px) {
  .pool-table-container table {
    overflow-x: auto;
    white-space: nowrap;
  }
}

.available-text {
  display: inline;
  color: #869cb1;
  font-size: 12px;
  font-weight: 400;
}

.add-game-hover-text {
  display: none;
  color: #869cb1;
  font-size: 12px;
  font-weight: 400;
}

/* ✅ Only trigger hover switch when .can-hover is present */
td.available:hover .available-text {
  display: none !important;
}

td.available:hover .add-game-hover-text {
  display: inline !important;
}

.current-division {
  background-color: #dfffea !important;
  border: 0.5px solid #17c653 !important;
}

.current-division.umpire-assigned {
  background-color: #e5f2fe !important;
  border: 0.5px solid #7fc0f9 !important;
}

.current-division.no-umpire {
  background-color: #ffffff !important;
  border: 0.5px solid #b9c6d3 !important;
}

.assigned.other-division {
  background-color: #f0f2f5 !important;
  border: 0.5px solid #b9c6d3 !important;
}

.assigned.other-division.umpire-assigned {
  background-color: #e5f2fe !important;
  border: 0.5px solid #7fc0f9 !important;
}

.assigned.other-division.no-umpire {
  background-color: #ffffff !important;
  border: 0.5px solid #b9c6d3 !important;
}
</style>